
import React, { Component } from 'react';
import StickyFixedHeader from "../../general/stickyHeader/stickyFixedHeader";
import { IoIosCloseCircleOutline } from "react-icons/io"
import { FaCheckCircle } from "react-icons/fa";

const currentComponentAction = require('../../../../utils/state/actions/component/currentComponentAction');
const stateManager = require('../../../../utils/state/stateManager');
const stringUtil = require('../../../../utils/string/stringUtil');
const constants = require('../../../../utils/domain/constants');

class OrderConfirmation extends Component 
{
    constructor(props)
    {
        super(props);
    }

    render()
    {
        return <div>
                    {this.renderHeader()}
                    {this.renderBody()}
                </div>
        
    }

    renderHeader()
    {
        var state = stateManager.getStore().getState();

        return <div>
                    <StickyFixedHeader>
                        <div className='AppBar'>
                            <table style={{width:'100%'}}>
                                <tr>
                                    <td style={{width:'99%'}}>
                                        <div  style={{paddingLeft:'10px', paddingRight:'10px',paddingTop:'5px'}}>
                                            <div>{state.property.name}</div>
                                            <div className='smallText'>{state.property.address}</div>
                                        </div>

                                    </td>
                                    {   
                                        stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                                        ? null
                                        : <td style={{whiteSpace:'nowrap'}}>
                                            <div style={{marginLeft:'10px', marginRight:'5px', fontSize:`var(--button-close-size)`, color:`var(--button-close-color)`}}
                                                onClick={()=>
                                                        {
                                                            var store = stateManager.getStore();
                                                            store.dispatch(currentComponentAction.createAction("store"));
                                                        }}>
                                                <IoIosCloseCircleOutline/>
                                            </div>
                                        </td>                                        
                                    }
                                </tr>
                            </table>
                            
                    
                            <hr style={{marginTop:'5px', marginBottom:'0px'}}/> 
                        </div>
                    </StickyFixedHeader> 
                </div>
    }

    renderBody()
    {
        var state = stateManager.getStore().getState();
        return <div style={{marginTop:'40px', marginLeft:'15px', marginRight:'15px', textAlign:'center'}}>
                    <div>
                        <FaCheckCircle size={48} color="#50C878"/>
                    </div>

                    <div style={{marginTop:'10px'}}><h3>Thank You!</h3></div>
                    <div>Order successfully sent to Kitchen</div>
                    <div style={{marginTop:'10px'}}>Your Order Number is <b>{state.lastOrderNumber}</b></div>
                    {
                        stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment)
                            ? <h4 style={{marginTop:'20px'}}>Please close the page.</h4>
                            : null
                    }
                </div>
    }
}

export default OrderConfirmation;